import { useQuery } from '@tanstack/react-query';
import { getPropertyManagerList } from '@/lib/coloc-api/admin';

export const useGetPropertyManagers = () => {
  return useQuery({
    queryKey: ['getPropertyManagerList'],
    queryFn: async () => {
      const response = await getPropertyManagerList();
      return response.data;
    },
  });
}; 